// services/productService.js
import api from './api';

/**
 * Получение списка всех товаров с параметрами фильтрации
 * @param {Object} params - Параметры запроса (search, categoryId, manufacturerId, page, pageSize)
 * @param {boolean} includeInactive - Включать ли неактивные записи
 * @returns {Promise<Array>} Массив товаров
 */
export const getProducts = async (params = {}, includeInactive = true) => {
  // Добавляем параметр для включения неактивных записей
  const queryParams = { 
    ...params,
    includeInactive: includeInactive 
  };
  
  const response = await api.get('/products', { params: queryParams });
  return response.data;
};

/**
 * Получение товара по ID
 * @param {string} id - GUID товара
 * @returns {Promise<Object>} Данные товара
 */
export const getProductById = async (id) => {
  const response = await api.get(`/products/${id}`);
  return response.data;
};

/**
 * Получение товара по штрихкоду
 * @param {string} barcode - штрихкод товара
 * @returns {Promise<Object>} Данные товара
 */
export const getProductByBarcode = async (barcode) => {
  const response = await api.get(`/products/barcode/${barcode}`);
  return response.data;
};

/**
 * Создание нового товара
 * @param {Object} productData - Данные для создания товара
 * @returns {Promise<Object>} Созданный товар
 */
export const createProduct = async (productData) => {
  const response = await api.post('/products', productData);
  return response.data;
};

/**
 * Обновление существующего товара
 * @param {string} id - GUID товара
 * @param {Object} productData - Данные для обновления
 * @returns {Promise<Object>} Обновленный товар
 */
export const updateProduct = async (id, productData) => {
  const response = await api.put(`/products/${id}`, productData);
  return response.data;
};

/**
 * Деактивация товара (мягкое удаление через обновление)
 * @param {string} id - GUID товара
 * @returns {Promise<boolean>} Результат операции
 */
export const deactivateProduct = async (id) => {
  const response = await api.delete(`/products/${id}`);
  return response.data;
};

/**
 * Активация товара (через обновление)
 * @param {string} id - GUID товара
 * @param {Object} productData - Полные данные товара
 * @returns {Promise<Object>} Обновленный товар
 */
export const activateProduct = async (id, productData) => {
  // Добавляем поле isActive в true
  const dataWithActive = {
    ...productData,
    isActive: true
  };
  const response = await api.put(`/products/${id}`, dataWithActive);
  return response.data;
};

/**
 * Быстрый поиск товаров для автодополнения
 * @param {string} searchTerm - Поисковый запрос
 * @param {number} limit - Максимальное количество результатов
 * @returns {Promise<Array>} Массив товаров для автодополнения
 */
export const searchProductsForAutocomplete = async (searchTerm, limit = 50) => {
  const response = await api.get('/products/search', { 
    params: { q: searchTerm, limit } 
  });
  return response.data;
};

export default {
  getProducts,
  getProductById,
  getProductByBarcode,
  createProduct,
  updateProduct,
  deactivateProduct,
  activateProduct,
  searchProductsForAutocomplete
};